import React, { useRef } from 'react';
import { v4 as uuid } from 'uuid';
import AddIcon from '../../assets/images/addIcon.svg';

export const ImageSelector = ({ onImagesSelected, imageAddError }) => {
  const inputRef = useRef(null);

  const onFileChange = ({ target }) => {
    let fileCollection = Array.from(target.files).slice(0, 5);
    if (fileCollection.length > 0) {
      Promise.all(fileCollection.map(generatePreviewData)).then((imgs) => {
        console.log('s', imgs);
        onImagesSelected(imgs);
        // this.props.onChange(imgs);
      });
    }
  };

  const generatePreviewData = (file) => {
    const fr = new FileReader();
    return new Promise((resolve, reject) => {
      fr.addEventListener('load', (e) => {
        let res = fr.result;
        resolve({ uri: res, file: file, id: uuid() });
      });
      fr.addEventListener('error', (e) => {
        reject();
      });
      fr.readAsDataURL(file);
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div
        className='add-image-wrapper'
        onClick={(e) => {
          if (inputRef) inputRef.current.click();
        }}
      >
        <img
          src={AddIcon}
          alt=''
          style={{ height: 22, width: 22}}
        />

        <input
          ref={inputRef}
          name='file_uploads'
          type='file'
          className='cusInput'
          id='file_uploads'
          accept='image/*'
          multiple
          value=''
          hidden
          onChange={onFileChange}
        />
      </div>
      {imageAddError ? (
        <span style={{ fontSize: '0.8rem', color: '#F96E4E' }}>
          {imageAddError}
        </span>
      ) : null}
    </div>
  );
};
